module.exports = __webpack_public_path__ + "img/shangpin.10f482da.png";